// src/components/cards/card-column.tsx
import isEmpty from 'lodash/isEmpty';
import styled from 'styled-components';
import dynamic from 'next/dynamic';
import Link from 'next/link';
import useResponsive from 'src/utils/device';

import { sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';

import Image from 'src/components/image';

type Props = {
  data: {
    id: number;
    nameTh: string;
    image: string;
    link: string;
  };
  eventDataLayer?: any;
  linkTo?: boolean;
  type?: 'FEATURE_IMAGE' | 'COVER_IMAGE' | 'CARD_LARGE' | 'CARD_MEDIUM' | 'CARD_SMALL' | 'NEXT_IMAGE' | string;
};

const CardColumn = ({ data, eventDataLayer = {}, linkTo = true, type }: Props) => {
  if (isEmpty(data)) return null;
  const responsive = useResponsive();
  const getFontSize = (text: string): string => {
    const len = text?.length || 0;

    if (responsive.isMobile) {
      if (len <= 10) return '18px';
      if (len <= 15) return '18px';
      if (len <= 20) return '14px';
      return '11px';
    }

    if (len <= 10) return '25px';
    if (len <= 15) return '20px';
    if (len <= 20) return '17px';
    return '14px';
  };

  return (
    <CardWrapper>
      {linkTo ? (
        <a href={data?.link || '#'} onClick={() => sendDataLayerGlobal({ ...eventDataLayer })}>
          <div className='card-inner'>
            <h3 className='title' style={{ fontSize: getFontSize(data?.nameTh) }}>
              {data?.nameTh}
            </h3>
            <div className='thumbnail'>
              <Image image={data?.image} title={data?.nameTh} decorative={true} />
            </div>
          </div>
        </a>
      ) : (
        <div onClick={() => sendDataLayerGlobal({ ...eventDataLayer })}>
          <div className='card-inner'>
            <h3 className='title' style={{ fontSize: getFontSize(data?.nameTh) }}>
              {data?.nameTh}
            </h3>
            <div className='thumbnail'>
              <Image image={data?.image} title={data?.nameTh} decorative={true} />
            </div>
          </div>
        </div>
      )}
    </CardWrapper>
  );
};

const CardWrapper = styled.div`
  cursor: pointer;

  a {
    text-decoration: none;
  }

  .card-inner {
    display: flex;
    flex-direction: column;
    border: 0px solid #e0e0e0;
    border-radius: 12px;
    background: white;
    overflow: hidden;
    transition: all 0.3s ease;

    &:hover {
      .thumbnail {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      }

      .title {
        color: #ed1a3b;
      }
    }
  }

  .title {
    font-size: 25px;
    font-weight: 700;
    color: #000;
    text-align: center;
    padding: 15px;
    margin: 0;
    transition: color 0.3s ease;
    min-height: 60px;
    @media (max-width: 768px) {
      min-height: 48px;
    }
  }

  .thumbnail {
    width: 100%;
    aspect-ratio: 1;
    overflow: hidden;
    border-radius: 12px;
    .lazyload-wrapper {
      height: 100%;
    }
    .resolution-image,
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  @media (max-width: 768px) {
    .title {
      font-size: 18px;
      padding: 10px;
    }
  }
`;

export default CardColumn;
